import { ANALYTICS_SCREEN_CREATE_PROMOTION, ANALYTICS_SCREEN_MANAGE_PROMOTIONS, ANALYTICS_SCREEN_PROMOTION_DETAILS, ANALYTICS_SCREEN_PROMOTION_DETAILS_CODES, ANALYTICS_SCREEN_PROMOTION_DETAILS_PRICING } from "../analytics/Sources";
export var managePartnersBaseRoute = '/manage/vendors/:partnerId(\\d+)';
export var promotionDetailsBaseRoute = "".concat(managePartnersBaseRoute, "/promos/:promotionId(\\d+)");
export var promotionsRoute = {
  name: ANALYTICS_SCREEN_MANAGE_PROMOTIONS,
  path: "".concat(managePartnersBaseRoute, "/promos"),
  isNestedRoute: true
};
export var createPromotionRoute = {
  name: ANALYTICS_SCREEN_CREATE_PROMOTION,
  path: "".concat(managePartnersBaseRoute, "/promos/create"),
  isNestedRoute: true
};
export var promotionDetailsRoute = {
  name: ANALYTICS_SCREEN_PROMOTION_DETAILS,
  path: "".concat(managePartnersBaseRoute, "/promos/:promotionId(\\d+)/details"),
  isNestedRoute: true
};
export var promotionDetailsCodesRoute = {
  name: ANALYTICS_SCREEN_PROMOTION_DETAILS_CODES,
  path: "".concat(managePartnersBaseRoute, "/promos/:promotionId(\\d+)/codes"),
  isNestedRoute: true
};
export var promotionDetailsPricingRoute = {
  name: ANALYTICS_SCREEN_PROMOTION_DETAILS_PRICING,
  path: "".concat(managePartnersBaseRoute, "/promos/:promotionId(\\d+)/pricing"),
  isNestedRoute: true
};
export var allManagePartnersRoutes = [promotionsRoute, createPromotionRoute, promotionDetailsRoute, promotionDetailsCodesRoute, promotionDetailsPricingRoute];